/* eslint-disable react/no-unknown-property */
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { Card, Col, Row, UncontrolledTooltip } from "reactstrap";
import "../../assets/scss/style.css";
import { withTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { successMsgHandler } from "common/successMsgHandler";
import { alerShow, dateformat } from "admin/commonFunction";
import Swal from "sweetalert2";
import AddAgent from "./addAgent";

import { getAllAgents, deleteAgent, createAgent, updateAgent, blockUnblockAgent, updateAgentShowAi } from "services/userServices";
import { LoaderContext } from "context/ContextProvider";
import { getCurrentUserRole, getCurrentUserId, getCurrentBrokerOfficeId, ROLES } from "common/roleConfig";
import Pagination, {
  bootstrap5PaginationPreset,
} from "react-responsive-pagination";




const Agents = ({ t }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [listingData, setListingData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [agentCount,setAgentCount] =useState(0);
  const [searchName, setSearchName] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(0);
  const [show, setShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState("");
  const [loaderStatus,setLoaderStatus] =useState(true);
  const[blockFilter,setBlockFilter] =useState("");
  const [deleteFilter, setDeleteFilter] = useState("");
  const [exporting, setExporting] = useState(false);
    
    // Simple filters for agents
    const [sortBy, setSortBy] = useState("");


  const perPage = 10;

  const handleClose = () => setShow(false);

  const normalizeAgentsPayload = (payload) => {
    if (Array.isArray(payload)) {
      return payload;
    }
    if (payload && typeof payload === "object") {
      return (
        payload.agents ||
        payload.items ||
        payload.admins ||
        payload.data ||
        []
      );
    }
    return [];
  };

  const getBrokerIdForCurrentUser = () => {
    const userRole = getCurrentUserRole();
    const brokerOfficeId = getCurrentBrokerOfficeId();
    return userRole === "2" ? brokerOfficeId : "";
  };

  const fetchData = (pagenumber, pagelimit, search = "", blockFilter = "", sortByParam = "", deleteFilterParam = "") => {
    try {
      console.log("fetchData called with:", { pagenumber, pagelimit, search, blockFilter, sortByParam, deleteFilterParam });
      setLoaderStatus(true);
      const currentSortBy = sortByParam || sortBy;
      const currentDeleteFilter = deleteFilterParam !== undefined ? deleteFilterParam : deleteFilter;
      
      // Get current user role and ID for role-based filtering
      const brokerId = getBrokerIdForCurrentUser();
      
      getAllAgents(pagenumber, pagelimit, search, "", "", true, "", currentSortBy, "", brokerId).then((res) => {
        // Normalize response into an array
        const payload = res?.data ?? res;
        console.log("API Response:", payload); // Debug log
        let agentsList = normalizeAgentsPayload(payload);
        if (!Array.isArray(agentsList)) agentsList = [];
        
        // Debug log to check agent structure
        if (agentsList.length > 0) {
          console.log("First agent structure:", agentsList[0]);
          console.log("Agent ID fields:", {
            id: agentsList[0]?.id,
            _id: agentsList[0]?._id
          });
          console.log("Agent registerOfficeId:", agentsList[0]?.registerOfficeId);
          console.log("Agent isDeleted:", agentsList[0]?.isDeleted);
        }
  
        // Apply block/unblock filter
        if (blockFilter === "blocked") {
          agentsList = agentsList.filter(agent => agent.isBlocked);
        } else if (blockFilter === "unblocked") {
          agentsList = agentsList.filter(agent => !agent.isBlocked);
        }

        // Apply delete filter
        if (currentDeleteFilter === "deleted") {
          agentsList = agentsList.filter(agent => agent.isDeleted === true);
        } else if (currentDeleteFilter === "notDeleted") {
          agentsList = agentsList.filter(agent => agent.isDeleted === false || agent.isDeleted === undefined);
        }
  
        setListingData(agentsList);
  
        // Set total count for pagination
        const totalRecords = payload?.total || payload?.totalCount || payload?.count || 0;
        const totalPages = Math.ceil(totalRecords / pagelimit) || 1;
        setTotalCount(totalPages);
  
        setLoaderStatus(false);
      });
    } catch (err) {
      setLoaderStatus(false);
      console.log(err);
    }
  };
  

  // Navigate to agent properties page
  const handleViewProperties = (agentId, agentName) => {
    history.push(`/admin/agents/${agentId}/properties`, { 
      agentName: agentName 
    });
  };

  useEffect(() => {
    fetchData(currentPage, perPage, "", "", sortBy, "");
  }, []); // Empty dependency array - only run once on mount

  const handleSearchClick = (e) => {
    const value = e.target.value;
    setSearchName(value);
    setCurrentPage(1);
    clearTimeout(typingTimeout);
    const timeoutId = setTimeout(() => {
      fetchData(1, perPage, value, blockFilter, sortBy, deleteFilter);
    }, 500);
    setTypingTimeout(timeoutId);
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    fetchData(page, perPage, searchName, blockFilter, sortBy, deleteFilter);
  };


  const formik = useFormik({
    initialValues: { name: "", email: "", phone_number: "" },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().required("Required"),
      email: Yup.string().required("Required"),
      phone_number: Yup.string().nullable(),
    }),
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  const handleFormSubmit = async (values) => {
    try {
      await (isEdit
        ? updateAgent(editId, values)
        : createAgent(values)
      ).then((res) => {
        toast.success(t(`${successMsgHandler(res.message)}`));
        handleClose();
        fetchData(currentPage, perPage, searchName, blockFilter, sortBy, deleteFilter);
      });
    } catch (err) {
      console.log(err);
      alerShow("Error!", "An error occurred !", "Error");
    }
  };

  const handleEdit = (element) => {
    formik.setValues({
      name: element?.name || "",
      email: element?.email || "",
      phone_number: element?.phone_number || "",
    });
    setEditId(element?.id || element?._id);
    setIsEdit(true);
    setShow(true);
  };

  const handleToggleBlock = async (id, current) => {
    blockUnblockAgent(id, !Boolean(current))
      .then((res) => {
        toast.success(t(res?.message || "Agent status updated successfully"));
        setListingData(prev => prev.map(a => (a.id === id || a._id === id) ? { ...a, isBlocked: !Boolean(current) } : a));
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Something went wrong");
      });
  };

  const handleToggleShowAi = async (id, current) => {
    const newValue = !Boolean(current);
    updateAgentShowAi(id, newValue)
      .then((res) => {
        toast.success(t(res?.message || "AI button visibility updated successfully"));
        setListingData(prev => prev.map(a => (a.id === id || a._id === id) ? { ...a, showAiButton: newValue } : a));
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Something went wrong");
      });
  };

  const handleDeleteAgent = (adminId) => {
    deleteAgent({ params: { adminId } })
      .then((response) => {
        // Optimistically remove the user from the table
          setListingData(prev => prev.filter(user => (user.id || user._id) !== adminId));
        // Show success alert
        toast.success(t(response?.message || "Agent Deleted successfully"));
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Error");
      });
  };

  const downloadCSV = (csvContent, filename) => {
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const buildCSVFromAgents = (agents) => {
    const headers = ["Name", "Email", "Affiliated Broker", "Created At", "Status"];
    const sanitize = (value) => {
      if (value === null || value === undefined) return "";
      const stringValue = String(value).replace(/"/g, '""');
      return `"${stringValue}"`;
    };
    const rows = agents.map((agent) => [
      
      sanitize(agent.name || ""),
      sanitize(agent.email || ""),
      sanitize(agent?.registerOfficeId?.companyName || "-"),
      sanitize(agent.createdAt ? dateformat(agent.createdAt) : ""),
      sanitize(agent?.isDeleted ? "Deleted" : "Not Deleted"),
    ]);
    const csvRows = [headers.join(","), ...rows.map((row) => row.join(","))];
    return csvRows.join("\n");
  };

  const handleExportAgents = async () => {
    try {
      setExporting(true);
      const brokerId = getBrokerIdForCurrentUser();
      const response = await getAllAgents(
        1,
        1000,
        searchName,
        "",
        "",
        true,
        "",
        sortBy,
        "",
        brokerId
      );
      const payload = response?.data ?? response;
      let agentsList = normalizeAgentsPayload(payload);

      if (blockFilter === "blocked") {
        agentsList = agentsList.filter((agent) => agent.isBlocked);
      } else if (blockFilter === "unblocked") {
        agentsList = agentsList.filter((agent) => !agent.isBlocked);
      }

      if (deleteFilter === "deleted") {
        agentsList = agentsList.filter((agent) => agent.isDeleted === true);
      } else if (deleteFilter === "notDeleted") {
        agentsList = agentsList.filter((agent) => agent.isDeleted === false || agent.isDeleted === undefined);
      }

      if (!agentsList.length) {
        toast.error(t("No Records Found"));
        setExporting(false);
        return;
      }

      const csv = buildCSVFromAgents(agentsList);
      const timestamp = new Date().toISOString().split("T")[0];
      downloadCSV(csv, `agents_${timestamp}.csv`);
      toast.success(t("Agents exported successfully"));
    } catch (error) {
      console.log(error);
      toast.error(t("Error while exporting agents"));
    } finally {
      setExporting(false);
    }
  };

  const ConfirmDelete = (adminId) => {
    // eslint-disable-next-line no-undef
    Swal.fire({
      title: t("Are you sure?"),
      text: t("you want to delete this agent!"),
      customClass: { popup: "my-swal-popup" },
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Yes, delete it!"),
      cancelButtonText: t("Cancel"),
    }).then((result) => {
      if (result.isConfirmed) handleDeleteAgent(adminId);
    });
  };

  return (
    <React.Fragment>
      <AddAgent
        show={show}
        handleClose={handleClose}
        formik={formik}
        t={t}
        submitting={false}
        isEdit={isEdit}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card className="card-transparent">
                <div className="mb-3">
                  <Row className="d-flex align-items-center">
                    <Col lg="4">
                      <h5 className=" text-color-gredient"> {t("Agents")} </h5>
                    </Col>
                    <Col
                      lg="8"
                      className="d-flex align-items-center justify-content-end"
                    >
                      <div className="common-filters search-box me-xxl-2 my-3 my-xxl-0 d-inline-block">
                        <div className="position-relative">
                          <label htmlFor="search-bar-0" className="search-label mb-0">
                            <span id="search-bar-0-label" className="sr-only">
                              Search this table
                            </span>
                            <input
                              id="search-bar-0"
                              type="search"
                              className="form-control"
                              placeholder={`${t("Search")}...`}
                              style={{ borderRadius: "4px" }}
                              value={searchName}
                              onChange={handleSearchClick}
                            />
                          </label>
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>

                      <div className="me-xxl-2 my-3 my-xxl-0 d-inline-block">
                      <select
                            className="form-control select2 mb-xxl-0"
                            style={{ width: "165px" }}
                            value={blockFilter}
                            onChange={(e) => {
                              const value = e.target.value;
                              setBlockFilter(value);
                              setCurrentPage(1);
                              fetchData(1, perPage, searchName, value, sortBy, deleteFilter);
                            }}
                               >
                                 <option value="">All Agents</option>
                                 <option value="unblocked">Unblocked Agents</option>
                                 <option value="blocked">Blocked Agents</option>
                               </select>
                               
                               </div>

                      <div className="me-xxl-2 my-3 my-xxl-0 d-inline-block">
                      <select
                            className="form-control select2 mb-xxl-0"
                            style={{ width: "165px" }}
                            value={deleteFilter}
                            onChange={(e) => {
                              const value = e.target.value;
                              setDeleteFilter(value);
                              setCurrentPage(1);
                              fetchData(1, perPage, searchName, blockFilter, sortBy, value);
                            }}
                               >
                                 <option value="">All Status</option>
                                 <option value="notDeleted">Not Deleted</option>
                                 <option value="deleted">Deleted</option>
                               </select>
                               
                               </div>


                      <div className="me-xxl-2 my-3 my-xxl-0 d-inline-block">
                        <select
                          className="form-control select2 mb-xxl-0"
                          style={{ width: "165px" }}
                          value={sortBy}
                          onChange={(e) => {
                            const value = e.target.value;
                            console.log("Sort filter changed to:", value);
                            setSortBy(value);
                            setCurrentPage(1);
                            fetchData(1, perPage, searchName, blockFilter, value);
                          }}
                        >
                          <option value="">Sort By</option>
                          <option value="name">Agent Name (A-Z)</option>
                          {/* <option value="propertiesSold">Properties Sold</option>
                          <option value="totalCommission">Total Commission</option>
                          <option value="activeListings">Active Listings</option>
                          <option value="closedDeals">Closed Deals</option> */}
                        </select>
                      </div>

                     
                      <button
                        type="button"
                        className="btn btn-primary ms-xxl-2 my-3 my-xxl-0"
                        onClick={handleExportAgents}
                        disabled={exporting || loaderStatus}
                      >
                        {exporting ? t("Exporting...") : t("Export Agents")}
                      </button>

                    </Col>
                  </Row>
                </div>
                
                
                <div className="table-responsive">
                  <Table
                    id="tech-companies-1"
                    className="table common-table table-nowrap table-bordered"
                  >
                    <Thead>
                      <Tr>
                        <Th>ID</Th>
                        
                        <Th>{t("Name")}</Th>
                        <Th>{t("Email")}</Th>
                       
                        <Th>Affiliated Broker</Th>
                        <Th>{t("Created At")}</Th>
                        <Th>Status</Th>
                        <Th>AI Button</Th>
                        <Th>{t("Action")}</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {loaderStatus ? (
                        <Tr>
                          <Td colSpan="9"> {t("Loading")} ... </Td>
                        </Tr>
                      ) : Array.isArray(listingData) && listingData.length !== 0 ? (
                        listingData.map((element, index) => (
                          <tr key={index}>
                            <td>
                              <span className="co-name"> {index+1}</span>
                            </td>
                            <td>{element?.name}</td>
                            <td>{element?.email}</td>
                           
                            <td>{element?.registerOfficeId?.companyName || "-"}</td>
                            <td>{dateformat(element.createdAt)}</td>
                            <td>
                              <span className={`badge ${element?.isDeleted ? "bg-danger" : "bg-success"}`}>
                                {element?.isDeleted ? "Deleted" : "Not Deleted"}
                              </span>
                            </td>
                            <td>
                              {element?.showAiButton === true ? (
                                <span className="badge bg-success">Enabled</span>
                              ) : (
                                <span className="badge bg-secondary">Disabled</span>
                              )}
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div
                                  id={`viewTooltip-${element.id || element._id}`}
                                  className="me-2 p-1 btn"
                                  onClick={() => handleViewProperties(element.id || element._id, element.name)}
                                >
                                  <i className="bx bx-show common-icons" />
                                  <UncontrolledTooltip placement="top" target={`viewTooltip-${element.id || element._id}`}>
                                    {"View Properties"}
                                  </UncontrolledTooltip>
                                </div>
                                <div
                                  id={`editTooltip-${element.id || element._id}`}
                                  className="me-2 p-1 btn"
                                  onClick={() => handleEdit(element)}
                                >
                                  <i className="bx bx-edit-alt common-icons" />
                                  <UncontrolledTooltip placement="top" target={`editTooltip-${element.id || element._id}`}>
                                    {"Edit"}
                                  </UncontrolledTooltip>
                                </div>
                                <div
                                  id={`toggleTooltip-${element.id || element._id}`}
                                  className="me-2 p-1 btn"
                                  onClick={() => handleToggleBlock(element.id || element._id, element?.isBlocked)}
                                >
                                  <i
                                    className={`mdi ${Boolean(element?.isBlocked) ? "mdi-toggle-switch" : "mdi-toggle-switch-off"} common-icons`}
                                    style={{ fontSize: "25px" }}
                                  />
                                  <UncontrolledTooltip placement="top" target={`toggleTooltip-${element.id || element._id}`}>
                                    {"Block/Unblock"}
                                  </UncontrolledTooltip>
                                </div>
                                <div
                                  id={`showAiTooltip-${element.id || element._id}`}
                                  className="me-2 p-1 btn"
                                  onClick={() => handleToggleShowAi(element.id || element._id, element?.showAiButton)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <i
                                    className={`mdi ${Boolean(element?.showAiButton) ? "mdi-robot" : "mdi-robot-off"} common-icons`}
                                    style={{
                                      fontSize: "25px",
                                      color: Boolean(element?.showAiButton) ? "#28a745" : "#6c757d",
                                      display: "inline-block",
                                    }}
                                  />
                                  <UncontrolledTooltip placement="top" target={`showAiTooltip-${element.id || element._id}`}>
                                    {Boolean(element?.showAiButton)
                                      ? "AI Button Enabled - Click to Disable"
                                      : "AI Button Disabled - Click to Enable"}
                                  </UncontrolledTooltip>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9">
                            <p className="text-center m-0">{t("No Records Found")}</p>
                          </td>
                        </tr>
                      )}
                    </Tbody>
                  </Table>
                </div>
                <Row className="mt-2">
                  <Col md={9}></Col>
                  <Col md={3}>
                  {totalCount > 0 && (
                  <Pagination
                    {...bootstrap5PaginationPreset}
                    current={currentPage}
                    total={totalCount}
                    onPageChange={(page) => handlePageClick(page)}
                    className="pagination justify-content-end gap-1"
                  />
)}

                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

Agents.propTypes = { t: PropTypes.any };

export default withTranslation()(Agents);
